import React, { useEffect, useRef, useState } from "react";
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import {
  apollo_available_accountgroup_path,
  isummary_path,
  accountgroupdetail_path,
  signin_path,
} from "../atom/Apollo_links";
import { ApolloGetApiToken } from "../atom/Apollo_Token";
import { STORAGE_KEY } from "../atom/Apollo_DataTable";

import Card from "@material-ui/core/Card/Card";
import List from '@material-ui/core/List';
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from '@material-ui/core/ListItemText';
import StarBorder from '@material-ui/icons/StarBorder';
import { ApolloContext } from "../atom/Apollo_Context";
import { apollo_useStyles, getModalStyle } from "../atom/Apollo_styles";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import classNames from "classnames";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import { useHistory, useParams } from "react-router-dom";
import { MUISortOptions, SelectableRows } from "mui-datatables";

import { Box } from "@material-ui/core";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { ApolloAxios, sleep } from "../atom/Apollo_ApiRequest3";
import { ApolloDataTable } from "../atom/Apollo_DataTable";
import { ApolloMessage } from "../atom/Apollo_Mesasge";
// 認証期間切れの処理
import { ApolloExpired } from "../atom/Apollo_Expired";

// エラーメッセージ
const ERROR_MESSGAE = [
  "アカウントグループ情報の取得に失敗しました",
];

type AccountGroup = {
  id: number,
  name: string,
  roleAuthorization: number,
  customSegment: number;
  geoSegment: number;
  accountList: Array<{
    id: number;
    name: string;
    trackerId: string;
  }>,
}

export const SelectAccountModal = () => {

  const classes = apollo_useStyles();
  const history = useHistory();
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const { state, dispatch } = React.useContext(ApolloContext);
  const [dispaccountgroup] = useState(state.current.accountGroupName);
  const [dispaccount] = useState(state.current.accountName);
  const flameClass = classNames(classes.root, classes.flame);
  const processing = useRef(false);
  const [list, setList] = useState<AccountGroup[]>([]);
  const { data, setmsg } = React.useContext(ApolloMessage);

  const { accountid } = useParams<{ accountid: string }>();
  const { accountgroupid } = useParams<{ accountgroupid: string }>();

  useEffect(() => {
    if (accountid !== undefined) {
      if (Number(accountid) != state.current.accountId
        && Number(accountid) != 0
      ) {
        //console.log("mismatch accountid")
        const errmsg = "表示する広告主アカウントを選択してください"
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: errmsg,
          }
        });
        setOpen(true);
      }
    } else if (accountgroupid !== undefined) {
      if (Number(accountgroupid) != state.current.accountGroupId
        && Number(accountgroupid) != 0) {
        //console.log("mismatch accountgroupid")
        const errmsg = "アカウントグループが設定されておりません"
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: errmsg,
          }
        });
        setOpen(true);
      }
    }

    if (ApolloGetApiToken() === "") {
      let url = "";
      if (history.location.pathname == signin_path) {
        url = signin_path;
      } else {
        url = signin_path + "?redirect=" + history.location.pathname;
      }
      history.push(url);
    } else {
      const url = apollo_available_accountgroup_path;
      ApolloAxios.get(url).then(response => {

        let isRoleReset = false;
        let isAdAccountNotExists = false;
        let accountGroupName = state.current.accountGroupName
        let accountName = state.current.accountName

        // システム管理権限の変更確認
        if (state.userprofile.systemAdmin !== response.data.userprofile.systemAdmin) {
          isRoleReset = true;
        }
        if (!isRoleReset && state.current.accountGroupId !== 0) {
          isRoleReset = true;
          for (const account of response.data.apolloList ?? []) {
            // アカウントグループの存在、ロール情報の変更有無を確認
            if (account.accountGroup.id === state.current.accountGroupId
              && account.accountGroup.roleAuthorization === state.current.roleAuthorization) {
              isRoleReset = false;
              accountGroupName = account.accountGroup.name;

              // 広告主アカウントの存在確認
              if (state.current.accountId !== 0) {
                isAdAccountNotExists = true;
                for (const val of account.accountList ?? []) {
                  if (val.id === state.current.accountId) {
                    isAdAccountNotExists = false;
                    accountName = val.name
                    break;
                  }
                }
              }

              break;
            }
          }
        }

        const current = {
          ...state.current,
          accountGroupId: isRoleReset ? 0 : state.current.accountGroupId,
          accountGroupName: isRoleReset ? "" : accountGroupName,
          accountId: isRoleReset || isAdAccountNotExists ? 0 : state.current.accountId,
          accountName: isRoleReset || isAdAccountNotExists ? "" : accountName,
          trackerId: isRoleReset || isAdAccountNotExists ? "" : state.current.trackerId,
          campaignId: isRoleReset || isAdAccountNotExists ? 0 : state.current.campaignId,
          roleAuthorization: isRoleReset ? 0 : state.current.roleAuthorization,
          customSegment: isRoleReset ? 1 : state.current.customSegment,
          geoSegment: isRoleReset ? 1 : state.current.geoSegment,
        };
        dispatch({
          type: "setAccount",
          payload: {
            ...state,
            userprofile: response.data.userprofile,
            authorization: response.data.authorization,
            current: current,
            apolloList: response.data.apolloList,
            accesstoken: response.data.accesstoken,
          }
        })

        // メッセージ表示
        if (isRoleReset || isAdAccountNotExists) {
          let errmsg = "";
          if (isRoleReset) {
            errmsg = "ロール情報の変更、またはアカウントグループ情報の削除がされたため、アカウント選択状態を初期化します。";
          } else if (isAdAccountNotExists) {
            errmsg = "広告主アカウント情報が削除されたため、広告主アカウントの選択状態を初期化します。";
          }
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: errmsg,
            }
          });
        }

        // アカウント選択状態の初期化等をする場合は、キャンペーン一覧画面に遷移
        if (isRoleReset || isAdAccountNotExists) {
          const localPathname = history.location.pathname;
          const pathname = localPathname.match(/^\/isummary/);
          if (pathname !== null && pathname[0] === (isummary_path)) {
            history.push(isummary_path);
            window.location.reload();
          } else {
            history.push(isummary_path);
          }
        }

        const accountGroups: AccountGroup[] = [];
        for (const account of response.data.apolloList ?? []) {
          const data: AccountGroup = {
            id: account.accountGroup.id,
            name: account.accountGroup.name,
            roleAuthorization: account.accountGroup.roleAuthorization,
            customSegment: account.accountGroup.customSegment,
            geoSegment: account.accountGroup.geoSegment,
            accountList: account.accountList,
          }
          accountGroups.push(data);
        }
        setList(accountGroups);
      }).catch(err => {
        console.log(err);
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, ERROR_MESSGAE[0], data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
        let url = "";
        if (history.location.pathname == signin_path) {
          url = signin_path;
        } else {
          url = signin_path + "?redirect=" + history.location.pathname;
        }
        history.push(url);

        sleep(300);

      });
    }
  }, [open]);

  const dispname = () => {
    return dispaccount ? dispaccountgroup + " : " + dispaccount : dispaccountgroup + " : -- ";
  }

  const [accountname,] = React.useState(dispname);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const onSubmit = (setType: string, accountgroupId: number) => {
    if (processing.current) return;
    processing.current = true;

    const pathName = history.location.pathname;
    switch (true) {
      case setType === "accountgroup":
        const path1 = pathName.match(/^\/.*\//);
        if (path1 !== null && path1[0] === accountgroupdetail_path) {
          if (pathName !== accountgroupdetail_path + accountgroupId) {
            history.push(accountgroupdetail_path + accountgroupId);
            window.location.reload();
          }
        } else {
          history.push(accountgroupdetail_path + accountgroupId);
        }
        break;

      case setType === "account":
        const path2 = pathName.match(/^\/isummary/);
        if (path2 !== null && path2[0] === (isummary_path)) {
          history.push(isummary_path);
          window.location.reload();
        } else {
          history.push(isummary_path);
        }
        break;

      default:
        break;
    }

    processing.current = false;
  };

  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "name",
      label: "アカウントグループ名",
      options: {
        filter: true,
        sort: false,
      }
    },
    {
      name: "",
      label: "詳細",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (idx: number) => {
          return (
            <KeyboardArrowRightIcon
              onClick={() => {
                dispatch({
                  type: "changeAccount",
                  payload: {
                    ...state,
                    current: {
                      ...state.current,
                      accountGroupId: state.apolloList[idx].accountGroup.id,
                      accountGroupName: state.apolloList[idx].accountGroup.name,
                      accountId: 0,
                      accountName: "",
                      trackerId: "",
                      roleAuthorization: state.apolloList[idx].accountGroup.roleAuthorization,
                      customSegment: state.apolloList[idx].accountGroup.customSegment,
                      geoSegment: state.apolloList[idx].accountGroup.geoSegment,
                    }
                  }
                });
                onSubmit("accountgroup", state.apolloList[idx].accountGroup.id);
                handleClose();
              }} style={{ cursor: "pointer" }} />
          );
        }
      },
    },
  ];

  const sortOrder: MUISortOptions = {
    name: "id",
    direction: 'desc',
  }
  const selectableRows: SelectableRows = 'none';
  const options = {
    filter: true,
    download: false,
    print: false,
    sort: true,
    sortOrder: localStorage.getItem(STORAGE_KEY.SELECT_ACCOUNT) ? undefined : sortOrder,
    selectableRows: selectableRows,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50],
    jumpToPage: true,
    expandableRows: true,
    expandableRowsHeader: false,
    expandableRowsOnClick: true,
    storageKey: STORAGE_KEY.SELECT_ACCOUNT,
    renderExpandableRow: (rowData: any, rowMeta: { rowIndex: number, dataIndex: number }) => {
      const colspan = rowData.length + 1;
      return (
        <TableRow>
          <TableCell colSpan={colspan}>
            <Row onSubmit={onSubmit} group={list[rowMeta.dataIndex]} />
          </TableCell>
        </TableRow>
      );
    },
    textLabels: {
      body: { noMatch: "該当データが存在しません" }
    },
  }

  return (
    <React.Fragment>
      <Button className={classes.accountbutton} onClick={handleOpen} color="inherit">
        <div className={classes.accountName}>
          <div className={classes.accountNameHidden}>{accountname}</div>
        </div>
        <ArrowDropDownIcon />
      </Button>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
        onClose={handleClose}
      >
        <React.Fragment>
          <div style={modalStyle} className={`${classes.accountpaper} ${classes.modalStyleWide}`}>
            <Card className={classes.root} square variant="outlined">
              <Box m={1} className={flameClass}>
                <ApolloDataTable
                  title=""
                  data={list ? list : []}
                  columns={columns}
                  options={options}
                />
              </Box>
            </Card>
          </div>
        </React.Fragment>
      </Modal>
    </React.Fragment>
  );
};

function Row(props: { onSubmit: any, group: AccountGroup }) {

  const { onSubmit, group } = props;
  const classes = apollo_useStyles();
  const { state, dispatch } = React.useContext(ApolloContext);

  return (
    <React.Fragment>
      <List component="div" disablePadding>
        {group.accountList?.length > 0 ?
          group.accountList.map((account) => (
            <ListItem
              button className={classes.selected}
              key={account.id}
              onClick={event => {
                dispatch({
                  type: "changeAccount",
                  payload: {
                    ...state,
                    current: {
                      ...state.current,
                      accountGroupId: group.id,
                      accountGroupName: group.name,
                      roleAuthorization: group.roleAuthorization,
                      customSegment: group.customSegment,
                      geoSegment: group.geoSegment,
                      accountId: account.id,
                      accountName: account.name,
                      trackerId: account.trackerId,
                    }
                  }
                });
                onSubmit("account", group.id);
              }}>
              {account.id === state.current.accountId ?
                <ListItemIcon>
                  <StarBorder />
                </ListItemIcon>
                : ""
              }
              <ListItemText primary={account.name} />
            </ListItem>
          ))
          : <ListItemText className={classes.blockMarginL}>有効なApolloアカウントがありません</ListItemText>
        }
      </List>
    </React.Fragment>
  );
}

